import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { GET, POST, loading, alert, tokens } from "../components/CustomComponent.js";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
import "../assets/css/manora-report.css";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      password_view: "password",
    };
  }
  async componentDidMount() {
    if (tokens) {
      const result = await GET("/api/v1/auth/profile");
      if (result?.status === true) {
        window.location.href = `/stock-onhand`;
      }
    }
    loading(false);
  }

  Login = async () => {
    const { t } = this.props;
    const { username, password } = this.state;
    if (!username.trim()) {
      alert("", "warning", t("login.alert_title"), t("login.please_fill_username"));
      return;
    } else if (!password.trim()) {
      alert("", "warning", t("login.alert_title"), t("login.please_fill_password"));
      return;
    }
    loading(true);
    let result = await POST("/api/v1/auth/login", {
      username: username.trim(),
      password: password,
    });
    if (result?.status === true) {
      localStorage.setItem("scp-acc-tk", btoa("Bearer " + result.data.token));
      const profileResult = await GET("/api/v1/auth/profile", null, "Bearer " + result.data.token);
      localStorage.setItem("scp-profile", JSON.stringify(profileResult?.data || {}));
      window.location.href = `/stock-onhand`;
    } else {
      alert("", "warning", t("login.alert_title"), result?.message || t("login.error_generic"));
    }
    loading(false);
  };

  render() {
    const { username, password, password_view } = this.state;
    const { t, i18n } = this.props;
    const locale = i18n.language;
    return (
      <div className="manora-gradient-bg d-flex flex-column align-items-center py-5 px-3">
        <div className="w-100 d-flex justify-content-end mb-4" style={{ maxWidth: 960 }}>
          <div className="d-flex" style={{ gap: 4, background: "rgba(255,255,255,0.15)", borderRadius: 999, padding: 4 }}>
            {["en", "th", "my"].map((code) => (
              <button
                key={code}
                type="button"
                className={`manora-pill ${locale === code ? "active" : ""}`}
                onClick={() => i18n.changeLanguage(code)}
              >
                {code.toUpperCase()}
              </button>
            ))}
          </div>
        </div>

        <div className="manora-logo-badge mb-3">IC</div>
        <div className="text-center text-white fw-bold text-24 mb-1">{t("login.app_name")}</div>
        <div className="text-center mb-4" style={{ color: "#e4d9fb" }}>
          {t("login.app_subtitle")}
        </div>

        <div className="manora-card" style={{ width: "100%", maxWidth: 420 }}>
          <h5 className="fw-bold text-dark mb-1">{t("login.heading")}</h5>
          <div className="mb-3">
            <small className="text-secondary">{t("login.subtext")}</small>
          </div>

          <label className="mb-1 text-12 fw-bold text-secondary">{t("login.username_label")}</label>
          <input
            className="form-control mb-3"
            type="text"
            placeholder={t("login.username_placeholder")}
            onChange={(e) => this.setState({ username: e.target.value })}
            value={username}
          />

          <label className="mb-1 text-12 fw-bold text-secondary">{t("login.password_label")}</label>
          <div className="position-relative">
            <input
              className="form-control mb-3"
              type={password_view}
              placeholder={t("login.password_placeholder")}
              onChange={(e) => this.setState({ password: e.target.value })}
              onKeyUp={(e) => {
                if (e.key === "Enter") this.Login();
              }}
              value={password}
            />
            <div
              className="wpx-40 hpx-40 d-flex justify-content-center align-items-center icon pointer position-absolute"
              style={{ right: 0, top: 0 }}
              onClick={() =>
                this.setState({
                  password_view: password_view === "password" ? "text" : "password",
                })
              }
            >
              {password_view === "password" ? "" : ""}
            </div>
          </div>

          <button
            type="button"
            className="btn w-100 mb-3 text-white fw-bold"
            style={{ background: "var(--manora-gradient)", border: "none", borderRadius: 10, padding: "10px 0" }}
            disabled={!username.trim() || !password.trim()}
            onClick={() => this.Login()}
          >
            {t("login.login_button")}
          </button>

          <hr />
          <div className="w-100 text-center">
            <small className="text-secondary">{t("login.mockup_note")}</small>
          </div>
        </div>

        <div className="text-center mt-3">
          <small style={{ color: "#e4d9fb" }}>
            {t("login.version_label")} {global.version}
          </small>
        </div>
      </div>
    );
  }
}

export default withTranslation()(Login);
